import { ApiResult, httpRequest, Urls } from './Shared';
import { TreebeardNode } from 'react-treebeard';

const MANAGE_USER_URL = '/adminUsers';
const MANAGE_SELF_URL = '/User';

export interface UserInfo {
    firstName: string;
    lastName: string;
    phone: string;
}

export interface UserUpdate extends UserInfo {
    email: string;
    username: string;
    companyId: number | null;
    propertyIds: number[];
    role: number;
    receiveTourSignupEmails: boolean;
    permissions:number[];
}

export interface User extends UserUpdate {
    id: number;
    dateModified: string;
    dateCreated: string;
    roleName: string;
    companyName: string;
    emailConfirmed: boolean;
    warmLeadsStatus: boolean;
}

export interface UserPasswordUpdate {
    currentPassword: string;
    newPassword: string;
}

export interface UserEmailUpdate {
    newEmail: string;
}

export interface UsernameUpdate {
    newUsername: string;
}

export const getTree = (): Promise<ApiResult<TreebeardNode[]>> => {
    return httpRequest<TreebeardNode[]>(`${Urls.BASE_URL}${MANAGE_USER_URL}/tree`, 'get');
};

const updateSelfHelper = (
    updateFields: UserEmailUpdate | UserPasswordUpdate | UserInfo | UsernameUpdate,
    slug: string
): Promise<ApiResult<undefined>> => {
    return httpRequest<undefined>(
        `${Urls.BASE_URL}${MANAGE_SELF_URL}/${slug}`,
        'put',
        updateFields
    );
};

export const getUser = (userId: number): Promise<ApiResult<User>> => {
    return httpRequest<User>(`${Urls.BASE_URL}${MANAGE_USER_URL}/${userId}`, 'get');
};

export const getMyUser = (): Promise<ApiResult<User>> => {
    return httpRequest<User>(`${Urls.BASE_URL}${MANAGE_SELF_URL}`, 'get');
};

export const updateUser = (
    userId: number,
    userUpdate: UserUpdate
): Promise<ApiResult<undefined>> => {
    return httpRequest<undefined>(
        `${Urls.BASE_URL}${MANAGE_USER_URL}/${userId}`,
        'put',
        userUpdate
    );
};

export const createUser = (newUser: UserUpdate): Promise<ApiResult<User>> => {
    return httpRequest<User>(`${Urls.BASE_URL}${MANAGE_USER_URL}`, 'post', newUser);
};

export const resendRegistration = (userId: number): Promise<ApiResult<undefined>> => {
    return httpRequest<undefined>(`${Urls.BASE_URL}${MANAGE_USER_URL}/resend`, 'post', userId);
};

export const deleteUser = (userId: number): Promise<ApiResult<undefined>> => {
    return httpRequest<undefined>(`${Urls.BASE_URL}${MANAGE_USER_URL}/${userId}`, 'delete');
};

export const updateSelfEmail = (emailUpdate: UserEmailUpdate): Promise<ApiResult<undefined>> => {
    return updateSelfHelper(emailUpdate, 'email');
};

export const updateSelfUsername = (
    usernameUpdate: UsernameUpdate
): Promise<ApiResult<undefined>> => {
    return updateSelfHelper(usernameUpdate, 'username');
};

export const updateSelfPassword = (
    passwordUpdate: UserPasswordUpdate
): Promise<ApiResult<undefined>> => {
    return updateSelfHelper(passwordUpdate, 'password');
};

export const updateSelfInfo = (userInfo: UserInfo): Promise<ApiResult<undefined>> => {
    return updateSelfHelper(userInfo, 'info');
};



// WEBPACK FOOTER //
// ./src/api/User.ts